import SingleSelectPage from "@components/SingleSelectPage"

const OPTIONS = [
  "onlyCoffeeTeaSoda",
  "aboutTwoGlasses",
  "twoToSixGlasses",
  "moreThanSixGlasses",
] as const

export default function WaterIntake() {
  return <SingleSelectPage translationKey="waterIntake" options={OPTIONS} />
}
